/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";
import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function Table3({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      managerId: "",
      industryId: "",
      type: "",
      status: "",
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };

  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        managerId: "",
        industryId: "",
        type: "",
        status: "",
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" style={{ textAlign: "center", maxWidth: 10 }}>
                STT
              </Td>
              <Td style={{ textAlign: "center" }}>
                Mã quản lý trên sàn giao dịch TMĐT của nhà cung cấp
              </Td>
              <Td style={{ textAlign: "center" }}>Mã nghành hàng, dịch vụ kinh doanh theo Sàn</Td>
              <Td style={{ textAlign: "center" }}>
                Loại hàng hóa tương ứng với mã nghành hàng, dịch vụ của Sàn
              </Td>
              <Td style={{ textAlign: "center" }}>Trạng thái</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="managerId"
                    value={item.managerId}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="industryId"
                    value={item.industryId}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable id={item.id} name="type" value={item.type} onChange={handleChange} />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "status", e.target.value)}
                  >
                    <option value="value1">Thêm mới</option>
                    <option value="value2">Thay thế</option>
                  </select>
                </Td>
              </tr>
            ))}
            <SoftBox
              display="flex"
              width={150}
              marginBottom={2}
              justifyContent="flex-start"
              gap={3}
              mt={2}
            >
              <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
                Thêm dòng
              </SoftButton>
            </SoftBox>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table3);

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
